var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondSolanaAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 134,
    viewBox: "0 0 126 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solana"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_18473)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6183,
    cy: 28.9146,
    rx: 24.6183,
    ry: 28.9146,
    transform: "matrix(0.973732 -0.227696 0.189703 0.981841 34 44.2109)",
    fill: "#28FFCD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M48.5298 57.894C48.6214 57.6792 48.8093 57.5199 49.0327 57.4676L74.7414 51.4559C75.2844 51.329 75.727 51.8618 75.5163 52.3887L71.8862 61.465C71.7973 61.6873 71.6059 61.8533 71.3769 61.9068L45.4017 67.9808C44.8515 68.1095 44.4076 67.5617 44.6332 67.0326L48.5298 57.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M53.229 82.2261C53.3206 82.0112 53.5085 81.8519 53.7319 81.7997L79.4407 75.788C79.9836 75.661 80.4262 76.1939 80.2155 76.7207L76.5854 85.797C76.4965 86.0193 76.3052 86.1853 76.0761 86.2389L50.1009 92.3128C49.5507 92.4415 49.1068 91.8938 49.3324 91.3647L53.229 82.2261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M52.8845 78.6344C53.0477 78.7916 53.2796 78.8542 53.5044 78.8016L78.8859 72.8664C79.4271 72.7399 79.6355 72.0584 79.2516 71.6703L72.6424 64.9884C72.479 64.8232 72.2415 64.756 72.0111 64.8099L46.3665 70.8066C45.8181 70.9348 45.614 71.6304 46.0122 72.014L52.8845 78.6344Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_18473",
    x: 0.959373,
    y: 0.15078,
    width: 124.995,
    height: 133.687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.95,
    result: "effect1_foregroundBlur_1877_18473"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSolanaAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SecondSolanaAdaptiveIcon.7e5fd3c0f3bce4d8ddd5a98aec6ac862.svg";
export { ForwardRef as ReactComponent };